import React, { useState } from "react";
import PortfolioFilter from "../components/portfolio/PortfolioFilter";
import VideoCard from "../components/portfolio/VideoCard";
import VideoModal from "../components/portfolio/VideoModal";
import { portfolioData, categories } from "../data/portfolioData";
import useDocumentTitle from "../hooks/useDocumentTitle";
import "./Portfolio.css";

const Portfolio = () => {
  useDocumentTitle("Portfolio");

  const [activeCategory, setActiveCategory] = useState("all");
  const [selectedVideo, setSelectedVideo] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const filteredVideos =
    activeCategory === "all"
      ? portfolioData
      : portfolioData.filter((video) => video.category === activeCategory);

  const handleViewVideo = (video) => {
    setSelectedVideo(video);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedVideo(null);
  };

  return (
    <div className="portfolio-page">
      <div className="portfolio-header">
        {/* <div className="container">
          <h1>Our Portfolio</h1>
          <p>Explore our collection of impactful video content</p>
        </div> */}
      </div>

      <div className="container">
        <PortfolioFilter
          categories={categories}
          activeCategory={activeCategory}
          onCategoryChange={setActiveCategory}
        />

        <div className="portfolio-grid">
          {filteredVideos.map((video) => (
            <VideoCard key={video.id} video={video} onView={handleViewVideo} />
          ))}
        </div>
      </div>

      {selectedVideo && (
        <VideoModal
          video={selectedVideo}
          isOpen={isModalOpen}
          onClose={handleCloseModal}
        />
      )}
    </div>
  );
};

export default Portfolio;
